import React from 'react';
import { useLocation } from 'react-router';

import { track } from '@data/track.js';

/**
 * One `view` beacon per route change, so every page (the homepage above all,
 * where ads land) shows up in the ra-mkt log with its campaign params. The
 * static demo pages fire their own inline beacon.
 */
export const PageViewBeacon: React.FC<{}> = () => {
  const { pathname } = useLocation();
  React.useEffect(
    function trackPageView() {
      track({ event: 'view' });
    },
    [pathname]
  );
  return null;
};
